
import auth from '../Auth'

const API_URL="https://api.nirmallabs.com/api/admin/v1";

export async function postData(fun = '', data = {}) {
    // Default options are marked with *
     let url = `${API_URL}/`+fun;
    const response = await fetch(url, {
      method: 'POST',
          headers: {
            'Authorization': 'Bearer '+auth.getToken(),
            'Content-Type': 'application/json'
        },
      body: JSON.stringify(data)
    });
    return response.json();
  }

  export async function NotificationSend(data = {}) {
    // Default options are marked with *
     let url = `https://api.nirmallabs.com/api/v1/fcm/send/`
    const response = await fetch(url, {
      method: 'POST',
          headers: {
            'Authorization': 'Bearer '+auth.getToken(),
            'Content-Type': 'application/json'
        },
      body: JSON.stringify(data)
    });
    return response;
}

export async function getData3(url = '',data={}){
  const response = await fetch(url,{
      'method':'POST',
       headers: {
        'Authorization': 'Bearer '+auth.getToken(),
        'Content-Type': 'application/json'
    },
    'body':JSON.stringify(data)
  }).catch((err)=>{
      console.log(err);
  });
  return response; 
}

  export async function getData2(url = ''){
    const response = await fetch(url,{
        'method':'GET',
         headers: {
          'Authorization': 'Bearer '+auth.getToken(),
          'Content-Type': 'application/json'
      }
    }).then(res=>res.json()).catch(err=>console.log(err));
    return response; 
}

  export async function getData(fun = ''){
    let url = `${API_URL}/`+fun;
    const response = await fetch(url,{
        'method':'GET',
         headers: {
          'Authorization': 'Bearer '+auth.getToken(),
          'Content-Type': 'application/json'
      }
    }).catch(()=>{
      auth.logout(()=>{
        this.props.history.push('/login')
      })
    });
    return response.json(); 
}


export const deleteData= async (path,ID)=>{
  let url = `${API_URL}/${path}/${ID}`;
 const response = await fetch(url, {
  method: 'DELETE',
  headers: {
      'Authorization': 'Bearer '+auth.getToken(),
      'Content-Type': 'application/json'
  }
}).catch(()=>{
  auth.logout(()=>{
    this.props.history.push('/login')
  })
});
  return response;
}

export const postFormData = async(path,data)=>{
  let url = `${API_URL}/${path}`;
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Bearer "+auth.getToken());

  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: data,
    redirect: 'follow'
  };
  const response = await fetch(url, requestOptions)
  .then(response => response.status===401?(
     auth.logout(()=>{
    this.props.history.push('/login')
  })
  ):response.text())
  .then(result => result)
  .catch(error => console.log('error', error));

    return response;
}

export const updateFormData = async(path,data)=>{
  let url = `${API_URL}/${path}`;
  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Authorization': 'Bearer '+auth.getToken(),
      'Content-Type': 'application/json'
    },
    body: data
    }).then(response => response.json()).catch(()=>{
      auth.logout(()=>{
        this.props.history.push('/login')
      })
    })

    return JSON.stringify(response);
}

export const LoginRequest= async(path,data)=>{
  let url = `https://api.nirmallabs.com/api/users/v1/login`;
  const response = await fetch(url, {
    method: 'POST', 
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
  }).then(res=>res.json()).catch(()=>{
    auth.logout(()=>{
      this.props.history.push('/login')
    })
  });
  return response;
}
